import { useQuery } from '@tanstack/react-query'

import { getClientFeatureGroups } from 'api/capabilities'
import { QUERIES } from 'constants/queries'

export const useClientHasCapability = (clientId: string, capability: string): boolean => {
  const { data: hasCapability = false } = useQuery(
    [QUERIES.FEATURE_GROUPS, clientId],
    () => getClientFeatureGroups(clientId),
    {
      select: (featureGroups) =>
        featureGroups.some((featureGroup) =>
          featureGroup.capabilities.some((featureGroupCapability) => featureGroupCapability.name === capability),
        ),
    },
  )

  return hasCapability
}
